<template>
  <section class="resources-feed__hero resources-hero">
    <div class="resources-hero__container container--1240">
      <h1 class="resources-hero__title">
        {{ title }}
      </h1>
      <p class="resources-hero__subtitle">
        {{ subtitle }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    subtitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
};
</script>

<style></style>
